import toast from 'components/partials/toast/toast';

import {
  SAVE_ERROR_FALLBACK,
  SAVE_ERROR_TITLE,
} from 'containers/admin/clients/client/tabs-components/critical-populations/critical-populations.constants';

import {
  getApiErrorDetail,
  getApiErrorStatus,
} from 'helpers/api/get-api-error-detail';

const STALE_ROW_STATUSES = new Set([404, 409]);

export const notifyCaptureError = (error: unknown): boolean => {
  toast.error({
    title: SAVE_ERROR_TITLE,
    message: getApiErrorDetail(error, SAVE_ERROR_FALLBACK),
  });

  const status = getApiErrorStatus(error);

  return status !== undefined && STALE_ROW_STATUSES.has(status);
};
